import React from 'react';
import Footer from "./Footer";

const PeoplePage = (props) => {
    return (
        <>
            <div className="peoplePage">
            <h6>OUR PEOPLE</h6>
      <div className="container peopleContainer">
        <div className="row">
          <div className="ahdy col-lg-6 text-start">
            <div className="shadowAhdy">
              <h1>AHDY</h1>
            </div>
            <div className="bio">
              {/* <img src={process.env.REACT_APP_IMAGE_STORAGE + props.galleries[0].image} alt="" className='ahdyImage'/> */}
              <h6>AHDY KHALIL</h6>
              <p>Co-Founder</p>
              <div className="bioText">
                <p>
                  Founded by entrepreneurs Ahdy Khalil and Brian Lalji, Zinc
                  Group is a Hong Kong based hospitality group specializing in
                  providing bold, innovative and alluring experiences in the
                  heart of entertainment districts.
                </p>
                <p>
                  Since our inception in 2007, Zinc Group has been deeply
                  focused on creating and delivering original concepts that
                  combine elements of music, dining and entertainment into one.
                </p>
                <p>
                  With an eye on exceptional service and guest satisfaction,
                  Zinc Group HK is always pushing boundaries and expanding
                  across Hong Kong and beyond.
                </p>
              </div>
            </div>
          </div>
          <div className="brian col-lg-6 text-end">
            <div className="shadowBrian">
              <h1>BRIAN</h1>
            </div>
            <div className="bio">
              {/* <img src={process.env.REACT_APP_IMAGE_STORAGE + props.galleries[1].image} alt="" className='brianImage'/> */}
              <h6>BRIAN LALJI</h6>
              <p>Co-Founder</p>
              <div className="bioText">
                <p>“Brian has always had a knack<br /> for seeing what others don’t see yet”</p>
                <p>Raised in Hong Kong, Brian spent his adolescent years working in different trades and eventually joining his families’ lifestyle business. </p>
                <p>Here he learnt to operate and grow multiple ventures including luxury jewelry and watches. His passion for hospitality naturally led him into the world of F&B.</p>
                <p>His business savvy and attention to detail have been the main drivers behind the flawless execution of Zinc Group’s rapid growth.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
            </div>
            <div className="footer d-lg-none">
        <Footer />
      </div>
        </>
    );
};

export default PeoplePage;